import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {AnalyticTrendingTracks, AnalyticTopTracks} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {get} = requestWrapper;

const requests = {
	getTrendingTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTrendingTracks>>(endpoints.trendingTracks, {
			params: {
				country,
			},
		}),
	getTopTracks: (country: string) =>
		get<DataResponseWrapper<AnalyticTopTracks>>(endpoints.topTracks, {
			params: {
				country,
			},
		}),
};

export default requests;
